<style lang="scss" scoped>
@import '../assets/css/style.scss';
  .no-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: 200px;
    font-size: 14px;
    color: #C8C8C8;
    text-align: center;
    .no-data-img {
      width: 100%;
    }
  }
</style>

<template>
  <div class="no-data" :style="{width: size + 'px'}">
      <img
        class="no-data-img"
        src="//kandian-1254383113.file.myqcloud.com/cloud/pc/no-data-course-list.png"
      />
      <div class="no-data-txt">{{title}}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/noData.vue